import React from 'react'
import { Link } from 'react-router-dom'
import './index.sass'

const SimpleLink = ({ route, text }) => {
  return (
    <Link className="simple-link" to={route}>
      {text}
      <div className="arrow" />
    </Link>
  )
}

export default SimpleLink
